module.exports = __webpack_public_path__ + "static/media/vucity-logo.8818ed15.png";